import { is } from "date-fns/locale";
import { isBusinessOrganization } from "./isBusinessOrganization"
import { isWorkspaceLockEnabled } from "./isWorkspaceLockEnabled";
import { isSubscriptionActive } from "./isSubscriptionActive";

export const isBusinessLocked = (organization) => {
    if(isWorkspaceLockEnabled === false) {
        return false;
    }

    if(!isBusinessOrganization(organization)) {
        return false;
    }

    return !isSubscriptionActive(organization.subscription);
}